import styled from "styled-components"
import media from "styled-media-query"

const Button = styled.button`
  background-color: #fff;
  border: solid 1px #0145a2;
  border-radius: 100px;
  box-shadow: 0 1px 6px #ccc;
  cursor: pointer;
  color: #0444a2;
  font-family: "Noto Sans JP", sans-serif;
  font-size: 12px;
  font-weight: 500;
  height: 4.2em;
  letter-spacing: 0.5px;
  text-align: center;
  width: 100%;
  ${media.greaterThan("small")`
    font-size: 16px;
    height: 64px;
    &:hover {
      background-color: #0145a2;
      box-shadow: none;
      color: #fff;
      transition: 0.4s;
    }
  `}
`
export default Button

export const BackButton = styled(Button)`
  background-color: #0247aa;
  color: #fff;
  ${media.greaterThan("small")`
    &:hover {
      background-color: #fff;
      border: solid 1px #0145a2;
      color: #0145a2;
    }
  `}
`
